import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import MapHero from '../components/MapHero';
import AppIntro from '../components/AppIntro';
import FeatureSection from '../components/FeatureSection';
import MediaFrame from '../components/MediaFrame';
import Roadmap from '../components/Roadmap';
import LandingHeader from '../components/LandingHeader';
import SocialLinks from '../components/SocialLinks';
import LandingFooter from '../components/LandingFooter';
import { FEATURE_LAYOUT } from '../constants';
import { getFeatureMediaSrcs } from '../lib/featureMedia';
import { colors } from '../theme/colors';
import { useLanguage } from '../context/LanguageContext';

const Page = styled.div`
  background: #fff;
  overflow-x: hidden;
`;

const COUPON_COLORS = {
  normal: colors.couponNormal,
  medium: colors.couponMedium,
  epic: colors.couponEpic,
};

function HomePage() {
  const { hash } = useLocation();
  const { t, language } = useLanguage();

  React.useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      window.setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 80);
    }
  }, [hash]);

  return (
    <Page>
      <SocialLinks />
      <LandingHeader />
      <main>
        <MapHero />
        <AppIntro />
        {FEATURE_LAYOUT.map((layout, index) => {
          const copy = t.features[layout.id];
          const badgeColor = COUPON_COLORS[layout.couponTier] || colors.couponNormal;
          const mediaSrcs = getFeatureMediaSrcs(layout.mediaKey, language);
          return (
            <FeatureSection
              key={layout.id}
              id={layout.id}
              eyebrow={copy.eyebrow}
              title={copy.title}
              body={copy.body}
              bullets={copy.bullets}
              reverse={layout.reverse}
              muted={index % 2 === 1}
              linkTo={layout.linkTo}
              linkLabel={layout.showLink ? copy.linkLabel : null}
              badgeColor={badgeColor}
              bulletColor={colors.accent}
              media={
                <MediaFrame
                  label={copy.mediaLabel}
                  src={mediaSrcs.length === 1 ? mediaSrcs[0] : undefined}
                  srcs={mediaSrcs.length > 1 ? mediaSrcs : undefined}
                  caption={copy.mediaLabel}
                />
              }
            />
          );
        })}
        <Roadmap />
      </main>
      <LandingFooter />
    </Page>
  );
}

export default HomePage;
